import { Collapse, Select, Tabs } from "antd";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import { Alert, Bets } from "../../../";
import { Loading } from "../../../";
import { Enums, CountryCodes, AppConfig } from "../../../../helpers";
import { setPropsMath } from "../../../../redux/actions/appActions";
import {
  loadSportEventsByDate,
  setEvent,
  getWeekMatchDays,
} from "../../../../redux/actions/sportEventsActions";
import EventRow from "../EventRow";
import { Images } from "../../../";
import { ReactSVG } from "react-svg";
import { ManageMemeberFavorite } from "../../../../redux/actions/membersActions";
import { updateFavoriteSportEvents } from "../../../../redux/actions/sportEventsActions";
const Option = Select.Option;
const TabPane = Tabs.TabPane;
const Panel = Collapse.Panel;

class Today extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sort: "league",
      collapseAll: false,
      addedActiveKeys: [],
      sportEventsFilter:2,
    };
  }

  componentDidMount() {
    const { match, setPropsMath, connected, weekMatchDays } = this.props;
    setPropsMath(match);
    // condition  to check if weekDays exist or not
    const doesWeekDaysExist =
      weekMatchDays &&
      Object.keys(weekMatchDays) &&
      Object.keys(weekMatchDays).length > 0;
    if (connected && doesWeekDaysExist) {
      // NOTE THAT WHEN INVOKING ONTODAYCLICK WE PASS THE KEY IN WEEK DAYS minus one TO THE BACK END , EX: defaultSport[0] - 1
      // getting the default sport, if it exists then display it''s events, if not then display the first sport in onweek days

      const defaultSport = Object.keys(weekMatchDays).filter(
        (item) => item == "1"
      );
      // when match.params.day is equal to zero that means display the default sport,else display the selected sport from match.params.day
      const displayFromURL = match.params.day != "0";
      const condition = displayFromURL
        ? match.params.day
        : defaultSport && defaultSport.length > 0
        ? Number(defaultSport[0] - 1).toString()
        : (Number(Object.keys(weekMatchDays)[0]) - 1).toString();
      // if the condition euals to -1 that means it's a last minite bets
      const isLastMin = condition == "-1" ? true : false;
      // -2 is indicator for today page and 0 is what the backend should receive  to display today events, so -2 is just an indicatoe to split today events from the rest of events

      this.onTodayClick(condition == "-2" ? "0" : condition, isLastMin);
    }
  }

  componentDidUpdate(prevProps) {
    const { match, setPropsMath, connected, weekMatchDays ,loadingSportEvents} = this.props;
    setPropsMath(match);
    if(loadingSportEvents !== prevProps.loadingSportEvents){
      this.setState({
        sportEventsFilter:2
      })
    }
    if (
      prevProps.match.url !== this.props.match.url ||
      prevProps.weekMatchDays !== this.props.weekMatchDays ||
      (!prevProps.connected && connected)
    ) {

      // NOTE THAT WHEN INVOKING ONTODAYCLICK WE PASS THE KEY IN WEEK DAYS minus one TO THE BACK END,EX: defaultSport[0] - 1
      // condition  to check if weekDays exist or not
      const doesWeekDaysExist =
        weekMatchDays &&
        Object.keys(weekMatchDays) &&
        Object.keys(weekMatchDays).length > 0;
      // getting the default sport, if it exists then display it''s events, if not then display the first sport in onweek days
      const defaultSport =
        doesWeekDaysExist &&
        Object.keys(weekMatchDays).filter((item) => item == "1");

      // when match.params.day is equal to zero that means display the default sport,else display the selected sport from match.params.day
      const displayFromURL = match.params.day != "0";
      const condition = displayFromURL
        ? match.params.day
        : doesWeekDaysExist
        ? defaultSport && defaultSport.length > 0
          ? Number(defaultSport[0] - 1).toString()
          : (Number(Object.keys(weekMatchDays)[0]) - 1).toString()
        : "0";
      // if the condition euals to -1 that means it's a last minite bets
      const isLastMin = condition == "-1" ? true : false;
      // -2 is indicator for today page and 0 is what the backend should receive  to display today events, so -2 is just an indicator to split today events from the rest of events
      this.onTodayClick(condition == "-2" ? "0" : condition, isLastMin);
    }
  }

  onTodayClick = (day = "0", isLastMin = false) => {
    const { history, loadSportEventsByDate, match } = this.props;
    // history.push(`${day}`);
    const request = {
      Data: {
        Feed: { FeedId: Number(match.params.feed) },
        Sport: { SportId: Number(match.params.sport) },
        Day: Number(day),
        IsLastMin: isLastMin,
      },
    };
    loadSportEventsByDate(request);
  };

  onTabChange(key) {
    const isLastMin = key == "-1" ? true : false;
    this.onTodayClick(key, isLastMin);
    this.setState({ collapseAll: false, leaguesIds: undefined });
  }

  getTabName(today, i) {
    let dayNumber = today + i + 1;
    dayNumber =
      dayNumber >= Enums.Days.length
        ? dayNumber - Enums.Days.length
        : dayNumber;
    return Enums.Days[dayNumber];
  }

  // getCountryCode = (name) => {
  //   let result =
  //   this.props.countryFlags &&
  //   this.props.countryFlags.filter((element) => {
  //     return element.countryName.toLowerCase() == name.toLowerCase();
  //   });
  // if (result && result.length > 0) {
  //   return result[0].countryFlagImagesName;
  // }
  // };
  addToFavorate = (e, tournamentUId , eventKey , isFaviorite) => {
    e.stopPropagation();
    const { ManageMemeberFavorite, match, history ,updateFavoriteSportEvents} = this.props;
    const favItemKey = `2-${tournamentUId}-${match.params.sport}`;
    const memberFavorites =
      localStorage.getItem("memberFavorites") &&
      JSON.parse(localStorage.getItem("memberFavorites"));
    // if memberFavorites not exist then stop the function, else complete
    if (!memberFavorites) return;
    //
    const existingIndex = memberFavorites.findIndex(
      (item) => item.key === favItemKey
    );
    if (existingIndex > -1) {
      let element = memberFavorites.filter((item) => item.key == favItemKey);
      let data = {
        favoriteId: element[0].favoriteId,
        favoriteType: {
          favoriteTypeId: 2,
        },
        feedId: Number(match.params.feed),
        sportId: Number(match.params.sport),
        elementId: Number(tournamentUId),
      };
      ManageMemeberFavorite(data);
    } else {
      let data = {
        favoriteType: {
          favoriteTypeId: 2,
        },
        feedId: Number(match.params.feed),
        sportId: Number(match.params.sport),
        elementId: Number(tournamentUId),
      };
      ManageMemeberFavorite(data);
    }
      this.setState({
        [tournamentUId]: this.state[tournamentUId] ? undefined : tournamentUId,
      });
      updateFavoriteSportEvents(tournamentUId)
    
  };
  setCurrentFilter =(filterType)=>{
    this.setState({
      sportEventsFilter:filterType
    })
  }
// old function
  // createGroups(list) {
  //   const { sort } = this.state;
  //   const {signedIn} = this.props

  //   let currentLeague = "";
  //   let currentCountry = "";
  //   let children = [];
  //   let groups = [];
  //   let leaguesIds = [];
  //   list.map((item, index) => {
  //     // if we are in the firts element, take the tournamentUId && isFavorite for the firts element, if we are in the last one take the index of the last element, else than that because of emtying children array you have to take the element before the current item which is index-1, this a correct work around for the implementation down below
  //     let tournamentUId = list[index ? index-1: index].eventTournament.tournamentUId;
  //     let eventKey = list[index ? index-1: index].key;
  //     let isFavorite = list[index ? index-1: index].eventTournament.isFavorite
  //     if (!currentLeague) {
  //       currentLeague = `${item.eventCategory.categoryDisplayName}/${
  //         item.eventTournament.tournamentDisplayName
  //       }`;
  //       currentCountry = item.eventCategory.categoryFlagCode;
  //       tournamentUId = list[index ? index-1: index].eventTournament.tournamentUId;
  //       eventKey = list[index ? index-1: index].key;
  //       isFavorite = list[index ? index-1: index].eventTournament.isFavorite
  //     }

  //     if (
  //       currentLeague ===
  //       `${item.eventCategory.categoryDisplayName}/${
  //         item.eventTournament.tournamentDisplayName
  //       }`
  //     ) {
  //       tournamentUId = list[index ? index-1: index].eventTournament.tournamentUId;
  //       eventKey = list[index ? index-1: index].key;
  //       isFavorite = list[index ? index-1: index].eventTournament.isFavorite
  //       children.push(
  //         <EventRow
  //           hideLeague={sort == "league"}
  //           {...this.props}
  //           key={item.key}
  //           id={item.key}
  //         />
  //       );

  //       if (list.length === 1) {
  //         // if one item only, create group
  //         groups.push(
  //           <Panel
  //             key={`${currentLeague}_${index}`}
  //             header={<>   {signedIn && (
  //               <div className="star-container">
  //                 <ReactSVG
  //                   className={`${
  //                     isFavorite
  //                       ? `favorite-icon-selected`
  //                       : ``
  //                   }`}
  //                   src={Images.LuckyNumberStar}
  //                   onClick={(e) =>
  //                     this.addToFavorate(
  //                       e,
  //                       tournamentUId,
  //                       eventKey,
  //                       isFavorite
  //                     )
  //                   }
  //                 />
  //               </div>
  //             )}<div className="league"><img
  //             style={{
  //               width: "25px",
  //               height: "15px",
  //               marginRight: "4px",
  //             }}
  //             src={
  //               AppConfig.countryFlagImagesPath +
  //               (currentCountry ? currentCountry : `eu`) +
  //               `.webp`
  //             }
  //             alt="country-flag"
  //           />&nbsp;<h2 className="heading-style">{currentLeague}</h2></div></>}
  //           >
  //             {children.map((item) => item)}
  //           </Panel>
  //         );
  //         leaguesIds.push(`${currentLeague}_${index}`);
  //       } else {
  //         if (index === list.length - 1 && list.length !== 1) {
  //           //if last item, create group
  //           groups.push(
  //             <Panel
  //               key={`${currentLeague}_${index}`}
  //               header={
  //                 <>
  //             {signedIn && (
  //                   <div className="star-container">
  //                     <ReactSVG
  //                       className={`${
  //                         isFavorite
  //                           ? `favorite-icon-selected`
  //                           : ``
  //                       }`}
  //                       src={Images.LuckyNumberStar}
  //                       onClick={(e) =>
  //                         this.addToFavorate(
  //                           e,
  //                           tournamentUId,
  //                           eventKey,
  //                           isFavorite
  //                         )
  //                       }
  //                     />
  //                   </div>
  //                 )}
  //                 <div className="league">
  //                   <img
  //                     style={{
  //                       width: "25px",
  //                       height: "15px",
  //                       marginRight: "4px",
  //                     }}
  //                     src={
  //                       AppConfig.countryFlagImagesPath +
  //                       (currentCountry ? currentCountry : `eu`) +
  //                       `.webp`
  //                     }
  //                     alt="country-flag"
  //                   />
  //                   &nbsp;
  //                   <h2 className="heading-style">{currentLeague}</h2>
  //                 </div>

  //                 </>
  //               }
  //             >
  //               {children.map((item) => item)}
  //             </Panel>
  //           );
  //           leaguesIds.push(`${currentLeague}_${index}`);
  //         }
  //       }
  //     } else {
  //       //create collapse
  //       tournamentUId = list[index ? index-1: index].eventTournament.tournamentUId;
  //       eventKey = list[index ? index-1: index].key;
  //       isFavorite = list[index ? index-1: index].eventTournament.isFavorite
  //       groups.push(
  //         <Panel
  //           key={`${currentLeague}_${index}`}
  //           header={
  //             <>
  //              {signedIn && (
  //                   <div className="star-container">
  //                     <ReactSVG
  //                       className={`${
  //                         isFavorite
  //                           ? `favorite-icon-selected`
  //                           : ``
  //                       }`}
  //                       src={Images.LuckyNumberStar}
  //                       onClick={(e) =>
  //                         this.addToFavorate(
  //                           e,
  //                           tournamentUId,
  //                           eventKey,
  //                           isFavorite
  //                         )
  //                       }
  //                     />
  //                   </div>
  //                 )}
  //             <div className="league">
  //               <img
  //                 style={{
  //                   width: "25px",
  //                   height: "15px",
  //                   marginRight: "4px",
  //                 }}
  //                 src={
  //                   AppConfig.countryFlagImagesPath +
  //                   (currentCountry ? currentCountry : `eu`) +
  //                   `.webp`
  //                 }
  //                 alt="country-flag"
  //               />
  //               &nbsp;
  //               <h2 className="heading-style">{currentLeague}</h2>

  //             </div>

  //               </>
  //               }
  //         >
  //           {children.map((item) => item)}
  //         </Panel>
  //       );
  //       leaguesIds.push(`${currentLeague}_${index}`);

  //       //change current league
  //       currentLeague = `${item.eventCategory.categoryDisplayName}/${
  //         item.eventTournament.tournamentDisplayName
  //       }`;
  //       currentCountry = item.eventCategory.categoryFlagCode;
  //       tournamentUId = list[index== list.length -1 ? index : index ? index-1: index].eventTournament.tournamentUId;
  //       eventKey = list[index== list.length -1 ? index : index ? index-1: index].key;
  //       isFavorite = list[index== list.length -1 ? index : index ? index-1: index].eventTournament.isFavorite
  //       children.length = 0;

  //       children.push(
  //         <EventRow
  //           hideLeague={sort == "league"}
  //           {...this.props}
  //           key={item.key}
  //           id={item.key}
  //         />
  //       );

  //       if (index === list.length - 1 && list.length !== 1) {
  //         //if last item, create group
  //         groups.push(
  //           <Panel
  //             key={`${currentLeague}_${index}`}
  //             header={
  //               <>
  //                {signedIn && (
  //                   <div className="star-container">
  //                     <ReactSVG
  //                       className={`${
  //                         isFavorite
  //                           ? `favorite-icon-selected`
  //                           : ``
  //                       }`}
  //                       src={Images.LuckyNumberStar}
  //                       onClick={(e) =>
  //                         this.addToFavorate(
  //                           e,
  //                           tournamentUId,
  //                           eventKey,
  //                           isFavorite
  //                         )
  //                       }
  //                     />
  //                   </div>
  //                 )}
  //               <div className="league">
  //                 <img
  //                   style={{
  //                     width: "25px",
  //                     height: "15px",
  //                     marginRight: "4px",
  //                   }}
  //                   src={
  //                     AppConfig.countryFlagImagesPath +
  //                     (currentCountry ? currentCountry : `eu`) +
  //                     `.webp`
  //                   }
  //                   alt="country-flag"
  //                 />
  //                 &nbsp;
  //                 <h2 className="heading-style">{currentLeague}</h2>
  //               </div>

  //               </>
  //             }
  //           >
  //             {children.map((item) => item)}
  //           </Panel>
  //         );

  //         leaguesIds.push(`${currentLeague}_${index}`);
  //       }
  //     }
  //   });

  //   return { groups, leaguesIds };
  // }
  // 

  // new function 
  createGroups(list) {
    const { sort } = this.state;
    const { signedIn } = this.props;
  
    let currentLeague = "";
    let currentCountry = "";
    let children = [];
    let groups = [];
    let leaguesIds = [];
  
    list.forEach((item, index) => {
      const currentItem = item;
      const prevItem = index > 0 ? list[index - 1] : null;
  
      if (!currentLeague) {
        currentLeague = `${item.eventCategory.categoryDisplayName}/${
          item.eventTournament.tournamentDisplayName
        }`;
        currentCountry = item.eventCategory.categoryFlagCode;
      }
  
      if (
        currentLeague ===
        `${item.eventCategory.categoryDisplayName}/${item.eventTournament.tournamentDisplayName}`
      ) {
        children.push(
          <EventRow
            hideLeague={sort === "league"}
            {...this.props}
            key={item.key}
            id={item.key}
          />
        );
  
        if (index === list.length - 1) {
          const { tournamentUId, isFavorite } = currentItem.eventTournament;
          const { key } = currentItem;
          groups.push(
            <Panel
              key={`${currentLeague}_${index}`}
              header={
                <>
                  {signedIn && (
                    <div className="star-container">
                      <ReactSVG
                        className={`${isFavorite ? "favorite-icon-selected" : ""}`}
                        src={Images.LuckyNumberStar}
                        onClick={(e) =>
                          this.addToFavorate(e, tournamentUId, key, isFavorite)
                        }
                      />
                    </div>
                  )}
                  <div className="league">
                    <img
                      style={{
                        width: "25px",
                        height: "15px",
                        marginRight: "4px",
                      }}
                      src={
                        AppConfig.countryFlagImagesPath +
                        (currentCountry ? currentCountry : `eu`) +
                        `.webp`
                      }
                      alt="country-flag"
                    />
                    &nbsp;
                    <h2 className="heading-style">{currentLeague}</h2>
                  </div>
                </>
              }
            >
              {children}
            </Panel>
          );
          leaguesIds.push(`${currentLeague}_${index}`);
        }
      } else {
        const { tournamentUId, isFavorite } = prevItem.eventTournament;
        const { key } = prevItem;
        groups.push(
          <Panel
            key={`${currentLeague}_${index}`}
            header={
              <>
                {signedIn && (
                  <div className="star-container">
                    <ReactSVG
                      className={`${isFavorite ? "favorite-icon-selected" : ""}`}
                      src={Images.LuckyNumberStar}
                      onClick={(e) =>
                        this.addToFavorate(e, tournamentUId, key, isFavorite)
                      }
                    />
                  </div>
                )}
                <div className="league">
                  <img
                    style={{
                      width: "25px",
                      height: "15px",
                      marginRight: "4px",
                    }}
                    src={
                      AppConfig.countryFlagImagesPath +
                      (currentCountry ? currentCountry : `eu`) +
                      `.webp`
                    }
                    alt="country-flag"
                  />
                  &nbsp;
                  <h2 className="heading-style">{currentLeague}</h2>
                </div>
              </>
            }
          >
            {children}
          </Panel>
        );
        leaguesIds.push(`${currentLeague}_${index}`);
  
        currentLeague = `${item.eventCategory.categoryDisplayName}/${
          item.eventTournament.tournamentDisplayName
        }`;
        currentCountry = item.eventCategory.categoryFlagCode;
        children = [
          <EventRow
            hideLeague={sort === "league"}
            {...this.props}
            key={item.key}
            id={item.key}
          />,
        ];
  
        if (index === list.length - 1) {
          const { tournamentUId,  isFavorite } = currentItem.eventTournament;
          const { key } = currentItem;
          groups.push(
            <Panel
              key={`${currentLeague}_${index}`}
              header={
                <>
                  {signedIn && (
                    <div className="star-container">
                      <ReactSVG
                        className={`${isFavorite ? "favorite-icon-selected" : ""}`}
                        src={Images.LuckyNumberStar}
                        onClick={(e) =>
                          this.addToFavorate(e, tournamentUId, key, isFavorite)
                        }
                      />
                    </div>
                  )}
                  <div className="league">
                    <img
                      style={{
                        width: "25px",
                        height: "15px",
                        marginRight: "4px",
                      }}
                      src={
                        AppConfig.countryFlagImagesPath +
                        (currentCountry ? currentCountry : `eu`) +
                        `.webp`
                      }
                      alt="country-flag"
                    />
                    &nbsp;
                    <h2 className="heading-style">{currentLeague}</h2>
                  </div>
                </>
              }
            >
              {children}
            </Panel>
          );
          leaguesIds.push(`${currentLeague}_${index}`);
        }
      }
    });
  
    return { groups, leaguesIds };
  }

  
  

  handleSortChange(value) {
    this.setState({ sort: value });
  }

  onCollapseChange(leaguesIds) {
    this.state.addedActiveKeys = this.state.addedActiveKeys.concat(
      leaguesIds[leaguesIds.length - 1]
    );
    this.setState({ leaguesIds, collapseAll: false });
  }
  // toggleCollapse() {
  //   const { collapseAll } = this.state;
  //   collapseAll
  //     ? this.setState({ collapseAll: false, leaguesIds: undefined })
  //     : this.setState({ collapseAll: true, leaguesIds: [] });
  // }

  render() {
    const {
      match,
      error,
      sportEvents,
      loadingSportEvents,
      loadingWeekMatchDays,
      weekMatchDaysError,
      weekMatchDays,
    } = this.props;
    const { sort } = this.state;
    const today = new Date().getDay();
    let result;

    if (loadingSportEvents) {
      return (
        <div className="events">
          {/* <div className="skeleton">
            <div className="row">
              <div className="loader" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
            </div>

            <div className="row">
              <div className="loader" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
            </div>

            <div className="row">
              <div className="loader" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
            </div>

            <div className="row">
              <div className="loader" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
              <div className="col" />
            </div>
          </div> */}
          <div className="lds-parent-ring">
            <div class="lds-ring">
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        </div>
      );
    }
    // a.eventCategory.categoryDisplayOrder -
    // b.eventCategory.categoryDisplayOrder
    if (sort === "time") {
      let events = Object.values(sportEvents).sort((a, b) => {
        return (
          moment.utc(a.eventDateOfMatch).valueOf() -
          moment.utc(b.eventDateOfMatch).valueOf()
        );
      });
      result = this.createGroups(events);
    } else {
      let events = Object.values(sportEvents).sort((a, b) => {
        return (
          a.eventCategory.categoryDisplayOrder -
          b.eventCategory.categoryDisplayOrder
        );
      });
      result = this.createGroups(events);
    }

    return (
      <div className="today-bets">
        <div className="events">
          {/* {loadingWeekMatchDays ? (
            <Loading />
          ) : weekMatchDaysError ? (
            <Alert type="error" message={weekMatchDaysError} />
          ) : weekMatchDays ? (
            <Tabs
              className="tabs-events"
              activeKey={match.params.day}
              onChange={(key) => this.onTabChange(key)}
            >
              {weekMatchDays.map((item) => {
                return item == -1 ? (
                  <TabPane tab="Last minute bets" key="-1" />
                ) : item == 0 ? (
                  <TabPane tab="TODAY" key="0" />
                ) : (
                  <TabPane tab={this.getTabName(today, item - 1)} key={item} />
                );
              })}
            </Tabs>
          ) : (
            ""
          )} */}

          {error && <div>{error}</div>}

          {!error && (
            <Bets.EventsHeader
              {...this.props}
              title={
                <Title
                  handleSortChange={(value) => this.handleSortChange(value)}
                  sort={this.state.sort}
                  // toggleCollapse={() => this.toggleCollapse()}
                  // collapseAll={this.state.collapseAll}
                />
              }
              setCurrentFilter={this.setCurrentFilter}
              sportEventsFilter={this.state.sportEventsFilter}
            />
          )}
          {this.state.sportEventsFilter ==3 && sportEvents && Object.values(sportEvents).length == 0 && ` No Favorites Added `}
          {!error && sportEvents && Object.keys(sportEvents).length > 0 && (
            <Collapse
              className="collaps"
              defaultActiveKey={
                result.leaguesIds &&
                result.leaguesIds
                  .splice(0, 5)
                  .concat(this.state.addedActiveKeys)
              }
              onChange={(key) => this.onCollapseChange(key)}
            >
              {Object.values(result.groups)}
            </Collapse>
          )}
        </div>
      </div>
    );
  }
}

const Title = (props) => {
  const { handleSortChange, sort } = props;

  return (
    <span
      style={{
        fontSize: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={() => {
        {
          sort == "league"
            ? handleSortChange("time")
            : handleSortChange("league");
        }
      }}
    >
      <div style={{ whiteSpace: "nowrap" }}>
        {sort == "time" ? `By Time` : `Leagues`}
      </div>
      <div style={{ marginLeft: "4px", filter: "var(--convert-brightness)" }}>
        <img src={Images.DownArrow} alt="down-arrow" />
      </div>
      {/* <Option value="league">Leagues</Option> */}
    </span>
  );
};

const mapStateToProps = (state) => {
  return {
    error: state.sportEvents.error,
    sportEvents: state.sportEvents.sportEvents,
    loadingWeekMatchDays: state.sportEvents.loadingWeekMatchDays,
    weekMatchDaysError: state.sportEvents.weekMatchDaysError,
    weekMatchDays: state.sportEvents.weekMatchDays,
    loadingSportEvents: state.sportEvents.loadingSportEvents,
    connected: state.signalr.staticConnected,
    countryFlags: state.general.countryFlags,
    weekMatchDays: state.sportEvents.weekMatchDays,
    signedIn: state.auth.signedIn,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    loadSportEventsByDate: (request) => {
      dispatch(loadSportEventsByDate(request));
    },
    getWeekMatchDays: (request) => {
      dispatch(getWeekMatchDays(request));
    },
    setPropsMath: (match) => {
      dispatch(setPropsMath(match));
    },
    setEvent: (item) => {
      dispatch(setEvent(item));
    },
    ManageMemeberFavorite: (data) => {
      dispatch(ManageMemeberFavorite(data));
    },
    updateFavoriteSportEvents: (tournamentUId) => {
      dispatch(updateFavoriteSportEvents(tournamentUId));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Today);
